import React, { ReactNode } from "react"

import { Tooltip } from "components/tooltip/Tooltip"

import { ReactComponent as AttentionIcon } from "../../../assets/icons/attention.svg"
import { ReactComponent as DiceIcon } from "../../../assets/icons/dice.svg"
import { ReactComponent as LineIcon } from "../../../assets/icons/line.svg"
import { ReactComponent as PencilIcon } from "../../../assets/icons/pencil.svg"
import { ReactComponent as TransferIcon } from "../../../assets/icons/transfer.svg"
import { ReactComponent as WalletIcon } from "../../../assets/icons/wallet.svg"

export interface BalanceCardProps {
  title: string
  value: string
  type: string
  real?: string
  bonus?: string

  secondaryLabel?: string
  secondaryValue?: ReactNode
  infoContent?: ReactNode

  setEditBalance?: (value: boolean) => void
}

export const BalanceCard = ({
  setEditBalance,
  title,
  value,
  type,
  real,
  bonus,
  secondaryLabel,
  secondaryValue,
  infoContent
}: BalanceCardProps) => {
  const renderIcon = () => {
    switch (type) {
      case "balance":
        return <WalletIcon className="w-6 h-6" />
      case "wager":
      case "deposits":
        return <LineIcon className="w-6 h-6" />
      case "withdrawals":
      case "ggr":
        return <TransferIcon className="w-6 h-6" />
      case "pnl":
        return <DiceIcon className="w-6 h-6" />
      default:
        return null
    }
  }

  return (
    <div className="flex flex-col gap-3 p-4 w-full rounded-[8px] border border-[rgba(0,0,0,0.1)] dark:border-transparent bg-[rgba(212,212,212,0.1)] dark:bg-[rgba(255,255,255,0.04)] text-white backdrop-blur-md">
      <div className="flex justify-between gap-4">
        <div className="text-[rgba(106,103,105,1)] dark:text-[rgba(156,163,175,1)] text-base">{title}</div>

        <div className="flex gap-4">
          {setEditBalance && (
            <button className="flex items-center justify-center h-full text-black dark:text-white" onClick={() => setEditBalance(true)}>
              <PencilIcon className="w-5 h-5 hover:text-[rgba(188,43,228,0.8)] transition-all" />
            </button>
          )}
          <div>{renderIcon()}</div>
        </div>
      </div>

      <div className="text-2xl text-[rgba(76,73,75,1)] dark:text-white">{value}</div>

      {secondaryLabel && (
        <>
          <div className="flex items-center gap-2 text-[rgba(106,103,105,1)] dark:text-[rgba(156,163,175,1)] text-base">
            <span>{secondaryLabel}</span>

            {infoContent ? (
              <Tooltip content={infoContent} side="bottom">
                <span className="inline-flex items-center">
                  <AttentionIcon className="cursor-pointer" />
                </span>
              </Tooltip>
            ) : null}
          </div>

          <div className="text-2xl text-[rgba(76,73,75,1)] dark:text-white">{secondaryValue ?? "-"}</div>
        </>
      )}

      {real && (
        <div className="flex justify-between items-center">
          <div className="text-[rgba(106,103,105,1)] dark:text-[rgba(156,163,175,1)] text-base">Real Money</div>
          <div className="text-[rgba(16,185,129,1)] text-base">{real}</div>
        </div>
      )}

      {bonus && (
        <div className="flex justify-between items-center">
          <div className="text-[rgba(106,103,105,1)] dark:text-[rgba(156,163,175,1)] text-base">Bonus Money</div>
          <div className="text-[rgba(59,130,246,1)] text-base">{bonus}</div>
        </div>
      )}
    </div>
  )
}
